import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'

import utils from './utils/utils'
import {request} from '@/utils/httpSever'
import {components} from '@/components/components'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// 引入echarts
import * as echarts from 'echarts'

import VueQuillEditor from 'vue-quill-editor'

Vue.use(VueQuillEditor /* { default global options } */)

Vue.config.productionTip = false
Vue.prototype.utils = utils
Vue.prototype.$request = request
// 将echarts放在全局中
Vue.prototype.$echarts = echarts

Vue.use(ElementUI, {size: 'small', zIndex: 999})
Vue.use(components)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title + Vue.prototype.utils.defaultTitleEnd
  } else {
    document.title = '易找标管理后台'
  }
  next()
})
Vue.prototype.showSubscriber = function () {
  if (store.state.token) {
    this.$request.verificationToken().then(res => {
      if (res.status === 200) {
        if (res.data) {
          store.commit('changeSubscriberShow', true)
        } else {
          store.commit('changeLoginDialogShow', true)
        }
      } else {
        this.requestError(res.status, res.message)
      }
    }, err => {
      console.log(err)
      this.requestFail(err)
    })
  } else {
    store.commit('changeLoginDialogShow', true)
  }
}
Vue.prototype.requestError = function (status, msg = '') {//状态码异常的处理
  if (status === 401 || status === 403) {
    if (router.currentRoute.path.search('backHome') === -1) {//客户端
      if (!store.state.loginDialogShow) {
        store.commit('changeLoginDialogShow', true)
      }
    } else {//后台管理系统
      utils.logout()
    }
  } else {
    if (msg) {
      this.$message({
        type: 'warning',
        message: msg
      })
    } else {
      this.$message({
        type: 'warning',
        message: '请求错误，请稍后重试'
      })
    }
  }
}

Vue.prototype.requestFail = function (errMsg) {//请求失败是的处理
  this.$message({
    type: 'warning',
    message: errMsg ? errMsg : '请求错误，请稍后重试！'
  })
}
Vue.prototype.currentUser = function () {
  if (store.state.token) {
    this.$request.currentUser().then((res) => {
      console.log(res)
      if (res.status === 200) {
        let resData = res.data
        store.commit('changeNickName', resData.nickname)
        store.commit('changeTel', resData.tel)
        if (resData.roles.some((item) => item.id === 1 || item.id === 2)) {//后台管理员
          console.log('后台管理员')
        } else {
          console.log('客户端用户')
        }
      }

    }, (err) => {
      console.log(err)
      this.requestFail(err)
    })
  }
}

//控制是否开启 console.log
/*let logDebug = false;
if (process.env.NODE_ENV === 'development') {
  logDebug = true;
} else if (process.env.NODE_ENV === 'production') {
  logDebug = false;
}
console.log = (function (oriLogFunc) {
  return function () {
    if (logDebug) {
      oriLogFunc.apply(this, arguments);
    }
  }
})(console.log);*/

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
